module.exports = __webpack_public_path__ + "static/recipe3-9738be3c1be3750c8a180300bb18d775.png";